module.exports = __webpack_public_path__ + "static/media/FAQ.083d2f25.png";